<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics

========================================================================================== -->

<template>

  <div id="dashboard-home">

    <div class="vx-row">
      <div class="vx-col w-full mb-base">

        <div class="knowledge-base-jumbotron bg-cover rounded-lg flex justify-center items-center">
          <video-background src="https://cdn.discordapp.com/attachments/870391445176086539/870404164193239050/Slowed.mp4" class="rounded-lg"
                            style="min-height: 22em; background-image: url(https://images.unsplash.com/photo-1620121692029-d088224ddc74?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=2089&q=80)">
            <div style="backdrop-filter: blur(55px); height: 100%;"
                 class="knowledge-base-jumbotron-content rounded-lg mb-base p-8 lg:p-12 flex justify-center items-center">
              <div class="flex justify-between items-center w-full">
                <div class="flex flex-wrap content-center pl-6 pr-6">
                  <h1 class="mb-2 text-white w-full pr-8" style="font-size: 4rem">Welcome Back, {{
                      activeUserInfo.first_name
                    }}</h1>
                  <p class="text-white w-full" style="font-size: 1.5rem">Your last
                    practiced course was
                    {{ activeCourseInfo.name }}</p>
                  <vs-progress
                    :percent="dashboard_progress.completion_percent" style="max-width: 600px"
                    class="block mt-6 shadow-md self-center w-2/3" color="success"></vs-progress>
                </div>
                <img
                  :src="activeCourseInfo.thumbnail !== null ? activeCourseInfo.thumbnail : 'https://cdn.discordapp.com/attachments/746242308084858900/848762736255172679/default-placeholder.png'"
                  class="rounded hidden lg:block" style="max-width: 245px; max-height: 245px; width: 30%; height: 30%">
              </div>
            </div>
          </video-background>
        </div>
      </div>
    </div>

    <div v-if="activeCourseInfo.selected === true" class="vx-row match-height mb-base">
      <div class="vx-col w-full">
        <vx-card class="carousel-example" title="Quick Simulation Selector">
          <swiper v-if="has_simulations" :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="swiperOption"
                  :key="swiperOption.slidesPerView">
            <swiper-slide v-for="item in items_local" :key="item.id" @click="navigate_to_detail_view(item.id)"
                          class="pt-1">
              <item-grid-view v-if="has_simulations" :item="item" style="background-color: #161719"
                              :class="!has_simulations ? 'hidden' : ''">
              </item-grid-view>
            </swiper-slide>
            <div slot="pagination" class="swiper-pagination"></div>
          </swiper>
          <dashboard-card-skeleton v-else class="mt-2"></dashboard-card-skeleton>
          <vs-button color="primary" icon-pack="feather" icon="icon-play" class="mb-1"
                     @click="$router.push('/simulation/search')">Show All Simulations
          </vs-button>
        </vx-card>
      </div>
    </div>
    <div v-if="!activeCourseInfo.selected" class="vx-row match-height mb-base">
      <div class="vx-col w-full">
        <vx-card class="carousel-example" title="Course Selector">
          <div v-if="courses_loaded">
            <swiper :dir="$vs.rtl ? 'rtl' : 'ltr'" :options="swiperOption">
              <swiper-slide v-for="item in courses_total" :key="item.id">
                <course-dashboard-card :item="item"/>
              </swiper-slide>
              <div slot="pagination" class="swiper-pagination"></div>
            </swiper>
          </div>
          <dashboard-card-skeleton v-else class="mt-2"></dashboard-card-skeleton>
          <h1 v-if="courses_none">You Have No Courses On Your Account</h1>
        </vx-card>
      </div>
    </div>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DashboardStatisticsCardLine from '@/components/statistics-cards/DashboardStatisticsCardLine.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import DashboardCardSkeleton from '@/components/skeleton-loading/DashboardCardSkeleton'
import CourseDashboardCard from '@/views/course/course-selector/components/CourseDashboardCard'
import 'swiper/dist/css/swiper.min.css'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import VideoBackground from 'vue-responsive-video-background-player'

export default {
  data () {
    return {

      items: [],
      items_local: [],

      courses_total: [],
      courses_loaded: false,
      courses_none: false,

      dashboard_progress: {
        completion_percent: 0
      },

      has_simulations: false,
      show_hidden_simulations: false,

      swiperOption: {
        slidesPerView: 5,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }

    }
  },
  components: {
    CourseDashboardCard,
    ItemGridView: () => import('../learn/search/components/ItemGridView'),
    VueApexCharts,
    DashboardStatisticsCardLine,
    VxTimeline,
    swiper,
    DashboardCardSkeleton,
    swiperSlide,
    VideoBackground
  },
  methods: {

    load_simulations_data (page = 0) {

      if (page === 0) {
        page = this.currentPage
      }

      this.$http.get(`courses/@active/simulation?amount=10&page=1&hidden=${this.show_hidden_simulations}`)
        .then(response => {

          if (response.data.data) {
            this.items = response.data.data
            this.has_simulations = true

            if (this.items.length === 0) {
              this.has_simulations = false
            }

            //if (this.$acl.check('admin')) {
            //  this.items = response.data.data
            //}

            this.items_local = this.items
          }

        }).catch(() => {
        })

    },
    get_course_list () {
      this.$http.get('users/@me/subscriptions')
        .then(subscriptions => {

          const newCourses = []

          if (subscriptions.data.data.length === 0) {
            this.courses_none = true
            this.courses_loaded = true
            // location.replace('https://www.youtube.com/watch?v=jE2VvGZktJo')
          }

          subscriptions.data.data.forEach(x => {
            this.$http.get(`courses/${x.course_id}`)
              .then(async response => {
                if (response.status === 200 && response.data.data.status === 'active') {
                  newCourses.push(response.data.data)
                  this.courses_total = newCourses
                  this.courses_loaded = true
                }
              })
          })

        })
    },
    navigate_to_detail_view () {
      this.$router.push({name: 'legacy-simulation-starter', params: {simulationId: this.item.id}})
        .catch(() => {
        })
    },
    load_dashboard_progress () {

      this.$http.get('progress/user/specific/@me/course/progress?id=@active')
        .then(response => {

          if (response.data.data) {
            this.dashboard_progress = response.data.data
          }
        })
        .catch(() => {})


    },
    load_current_selector () {
      if (this.activeCourseInfo.selected) {
        this.load_simulations_data()
      }

      if (!this.activeCourseInfo.selected) {
        this.get_course_list()
      }
    },
    resizedWindow () {
      const width = window.innerWidth
      if (width > 2200) {
        this.swiperOption.slidesPerView = 5
      }
      if (width < 1900) {
        this.swiperOption.slidesPerView = 4
      }
      if (width < 1500) {
        this.swiperOption.slidesPerView = 3
      }
      if (width < 950) {
        this.swiperOption.slidesPerView = 2
      }
      if (width < 500) {
        this.swiperOption.slidesPerView = 1
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizedWindow)
  },
  beforeMount () {
    this.load_dashboard_progress()
    this.load_current_selector()
    this.resizedWindow()
    window.addEventListener('resize', this.resizedWindow)

    if (this.activeCourseInfo.selected === '') {
      this.$store.dispatch('auth/refreshCourseObject').then(() => {
        this.load_current_selector()
      })
    }

  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  },
  watch: {
    // activeCourseInfo (newValue) {
    //   alert(`yes, computed property changed: ${newValue}`)
    // }
  }
}
</script>
